import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwittwerIcon from "@mui/icons-material/Twitter";
import MailIcon from "@mui/icons-material/Mail";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { FaLinkedin, FaTiktok } from "react-icons/fa";
import { connect } from "react-redux";
import { logout } from "../store/actions/authActions";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Avatar, Button, Drawer, Grid, Link, Tooltip } from "@mui/material";
import { centered_flex_box, left_flex_box, right_flex_box } from "./Styles";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import { UserLogin } from "../../Pages";
import StarsIcon from "@mui/icons-material/Stars";
import YouTube from "@mui/icons-material/YouTube";
import { useTranslation } from "react-i18next";
import { Instagram, Mail, Phone } from "@mui/icons-material";

function Footer({ auth }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const token = auth?.token || "";
  const header = token.split(" ");
  const role = header[0];
  const location = useLocation();

  const route = (path) => {
    navigate(path);
  };

  return (
    <>
      <Box
        sx={{
          bgcolor: "var(--secColor)",
          color: "var(--appBg)",
          width: "100vw",
          padding: 5,
          paddingBottom: 0,
          mt: 2,
        }}
      >
        <Grid container spacing={isMobile ? 5 : 10} mb={2}>
          <Grid item xs={isMobile ? 12 : 6}>
            <Typography fontSize={20} fontWeight="bold">
              About Us
            </Typography>
            <Typography textAlign="justify" fontWeight="light">
              Streamline Healthcare.

              Patients find top-tier doctors, pharmacies, comprehensive diagnostic services, home health, hospices & facilities.

              Providers & Clients expand reach, streamline communication & referrals.

              Order medical supplies delivered directly to your door.

              All in one network.

              Together, we empower well-being for a healthier you.
            </Typography>
          </Grid>
          <Grid item xs={isMobile ? 12 : 2}>


          </Grid>
          <Grid item xs={isMobile ? 12 : 4}>
            <Box padding={1}>
              <Typography fontSize={20} fontWeight="bold">
                Follow Us
              </Typography>
              <Instagram />{" "}
              <NavLink
                to={"https://www.instagram.com/euphorbia_ormedex/"}
                target="_blank"
              >
                Ormedex
              </NavLink>
              {/* 
              <Typography textAlign="justify">
                <WhatsAppIcon />{" "}
                <NavLink
                  to={"https://wa.me/201207325333"}
                  target="_blank"
                >
                  POV Pix
                </NavLink>
              </Typography>
              <Typography textAlign="justify">
                <Phone />{" "}
                <NavLink
                  to={"tel:+201207325333"}
                  target="_blank"
                >
                  +201207325333
                </NavLink>
              </Typography> */}
              <Typography textAlign="justify">
                <Mail />{" "}
                <NavLink
                  to={"mailto:support@ormedex.com"}
                  target="_blank"
                >
                  support@ormedex.com
                </NavLink>
              </Typography>
            </Box>
            <Box padding={1}>
              <Typography fontSize={20} fontWeight="bold">
                Policies
              </Typography>
              <Typography textAlign="justify">
                <NavLink
                  to={"/policy/privacy"}
                  replace
                >
                  Privacy Policy
                </NavLink>
              </Typography>
              <Typography textAlign="justify">
                <NavLink
                  to={"/terms"}
                  replace
                >
                  Terms & Conditions
                </NavLink>
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <hr
          style={{
            borderTop: "solid 2px var(--appBg)",
            opacity: "100%",
            margin: 0,
          }}
        />
      </Box>
      <Box
        sx={{
          bgcolor: "var(--secColor)",
          color: "var(--appBg)",
          width: "100vw",
          padding: 4,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography fontWeight="bold">
              © 2025 Ormedex All Rights Reserved
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{ ...centered_flex_box, flexDirection: "column" }}
          >
          
          </Grid>
          <Grid item xs={4} sx={right_flex_box}>
            <Typography fontWeight="bold">
              <NavLink
                to={"https://linktr.ee/integra.tech"}
                target="_blank"
              >
                Developed By Integra IT Solutions
              </NavLink>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state?.auth,
});

const mapDispatchToProps = { logout };

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
